<template>
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 8.20312L8 16.2031"
      stroke="#888888"
      stroke-width="2"
      stroke-linecap="round"
    />
    <path
      d="M16 8.20312L16 16.2031"
      stroke="#888888"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
</template>
